import GuaranteePolicyClaimService from '../services/guarantee-policy-claim-service';

const emptyClaim = (disputeId) => ({
  hasLodgedMeasure: true,
  disputeId,
  retrofitProjectId: '',
  projectReference: '',
  propertyPostcode: '',
  propertyAddressLine1: '',
  guaranteeProviderId: '',
  policyReference: '',
  financialProductId: '',
  issuedBy: '',
  reasonForSignposting: '',
  signpostingToGuaranteeProviderDt: null,
  claimStage: 'Signposted to Guarantee Provider',
  guaranteeProviderRejectionReason: '',
  claimOpenedWithGuaranteeProviderDt: null,
  closureDt: null,
  lodgementMeasuresOnPolicy: [],
  lodgementMeasuresClaimedAgainst: [],
});

const normaliseDates = (claim) => {
  if (!claim) return claim;
  if (claim.hasLodgedMeasure === null || claim.hasLodgedMeasure === undefined) {
    claim.hasLodgedMeasure = claim.lodgementMeasuresOnPolicy?.some((measure) => measure.lodgedMeasure) || false;
  }
  [
    'signpostingToGuaranteeProviderDt',
    'claimOpenedWithGuaranteeProviderDt',
    'closureDt',
    'createdAt',
    'updatedAt'
  ].forEach((key) => {
    if (claim[key]) {
      claim[key] = new Date(claim[key]);
    }
  });
  return claim;
};

export const guaranteePolicyClaim = {
  namespaced: true,
  state: {
    claims: null,
    claim: null,
    options: null,
  },
  actions: {
    newClaim({ commit, state }, disputeId) {
      if (state.claim?.disputeId === disputeId && !state.claim.guaranteePolicyClaimId) {
        return;
      }

      commit('setClaim', emptyClaim(disputeId));
    },
    clearNewClaimDraft({ commit, state }, disputeId) {
      if (state.claim?.disputeId === disputeId && !state.claim.guaranteePolicyClaimId) {
        commit('setClaim', null);
      }
    },
    listClaims({ commit }, disputeId) {
      commit('setIsBusy', true, { root: true });
      return GuaranteePolicyClaimService.list(disputeId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setClaims', result.model || []);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getClaim({ commit, dispatch }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setClaim', null);
      return GuaranteePolicyClaimService.get(payload.guaranteePolicyClaimId)
        .then((result) => {
          dispatch('disputes/get', { disputeId: payload.disputeId }, { root: true });
          commit('setIsBusy', false, { root: true });
          commit('setClaim', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getOptions({ commit }, disputeId) {
      commit('setIsBusy', true, { root: true });
      return GuaranteePolicyClaimService.options(disputeId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setOptions', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    createClaim({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return GuaranteePolicyClaimService.create(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setClaim', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    updateClaim({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return GuaranteePolicyClaimService.update(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setClaim', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    deleteClaim({ commit }, guaranteePolicyClaimId) {
      commit('setIsBusy', true, { root: true });
      return GuaranteePolicyClaimService.delete(guaranteePolicyClaimId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setClaims(state, claims) {
      state.claims = claims?.map((claim) => normaliseDates(claim));
    },
    setClaim(state, claim) {
      state.claim = normaliseDates(claim);
    },
    setOptions(state, options) {
      state.options = options;
    },
  },
};
